<section class="auth-card auth-onboarding" aria-labelledby="onboarding-title">
  <div class="auth-form" [formGroup]="form" *ngIf="!loading()">
    <div *ngIf="screen() === 'intro'" class="auth-onboarding__intro">
      <h1 class="auth-card__title auth-card__title--left" id="onboarding-title">{{ intro.title }}</h1>
      <p class="auth-onboarding__subtitle">{{ intro.subtitle }}</p>

      <div class="auth-onboarding__actions">
        <pa-button
          label="Ответить"
          [fullWidth]="true"
          styleClass="auth-submit"
          [disabled]="questions().length === 0"
          (click)="startQuestionnaire()"
        />
        <pa-button
          label="Пропустить"
          variant="outlined"
          severity="secondary"
          [fullWidth]="true"
          styleClass="auth-submit auth-submit--outlined"
          (click)="skip()"
        />
      </div>
    </div>

    <ng-container *ngIf="currentQuestion() as question">
      <div class="auth-onboarding__question">
        <div class="auth-card__header">
          <pa-button
            icon="pi pi-arrow-left"
            variant="outlined"
            size="small"
            severity="secondary"
            aria-label="Назад"
            (click)="back()"
          />
          <div class="auth-card__intro">
            <h1 class="auth-card__title auth-card__title--left" id="onboarding-title">
              {{ question.name }}
            </h1>
          </div>
        </div>

        <div
          *ngIf="question.uiType === 'radio'"
          class="auth-onboarding__options"
          role="radiogroup"
          [attr.aria-label]="question.name"
        >
          <label
            *ngFor="let option of question.options"
            class="auth-onboarding__option"
            [attr.for]="optionInputId(question, option)"
          >
            <p-radioButton
              [inputId]="optionInputId(question, option)"
              [formControlName]="controlName(question)"
              [value]="option.id"
            />
            <span>{{ option.label }}</span>
          </label>
        </div>

        <div
          *ngIf="question.uiType === 'checkbox'"
          class="auth-onboarding__options auth-onboarding__options--checkbox"
          role="group"
          [attr.aria-label]="question.name"
        >
          <label
            *ngFor="let option of question.options"
            class="auth-onboarding__option"
            [attr.for]="optionInputId(question, option)"
          >
            <p-checkbox
              [inputId]="optionInputId(question, option)"
              [binary]="true"
              [ngModel]="isCheckboxChecked(question, option.id)"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="toggleCheckbox(question, option.id, $event)"
            />
            <span>{{ option.label }}</span>
          </label>
        </div>

        <div class="auth-onboarding__actions">
          <pa-button
            label="Продолжить"
            [fullWidth]="true"
            styleClass="auth-submit"
            [disabled]="!canContinue(question)"
            (click)="continue()"
          />
          <pa-button
            *ngIf="question.allowSkip"
            label="Пропустить"
            variant="outlined"
            severity="secondary"
            [fullWidth]="true"
            styleClass="auth-submit auth-submit--outlined"
            [disabled]="saving()"
            (click)="skip()"
          />
        </div>
      </div>
    </ng-container>

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </div>
</section>
